<template>
  <v-card class="my-6">
    <v-btn
      :disabled="disableButton"
      small
      block
      color="error "
      @click="removeWilayah(index)"
      >Hapus Wilayah
      <v-icon small class="ml-1">mdi-minus-circle-outline</v-icon></v-btn
    >

    <v-row class="pa-2">
      <v-col cols="12" sm="8" md="8">
        <v-autocomplete
          v-model="wilayahUpdate"
          :items="allowListWilayah"
          label="Kode Wilayah"
          item-text="nama_wilayah"
          item-value="kode_wilayah"
          clearable
          :disabled="disableButton"
        />
      </v-col>

      <v-col cols="12" sm="4" md="4">
        <v-switch
          v-model="kodeposAllUpdate"
          :disabled="disableButton || disableSwitch"
          label="All Kode Pos"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12" v-if="!showStatusKodepos">
        <v-autocomplete
          v-model="kodeposUpdate"
          :items="listKodeposDefault"
          label="Kode Pos - Kecamatan, Kota"
          item-text="text"
          item-value="id"
          hide-selected
          multiple
          chips
          small-chips
          :disabled="disableButton"
          clearable
          :search-input.sync="searchKodepos"
          :loading="loadingKodepos"
        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-if="item == Object(item)"
              v-bind="attrs"
              color="primary"
              :input-value="selected"
              label
              small
              class="rounded-xl"
              :disabled="disableButton"
            >
              <span class="pr-2">
                {{ item.text }}
              </span>
              <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
            </v-chip>
          </template>

          <template v-slot:prepend-item>
            <v-list-item
              active-class="deep-purple--text text--accent-4"
              @click="allKodepos"
            >
              <v-list-item-icon>
                <v-icon>mdi-magnify</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-text="'All Kode Pos - Kecamatan, Kota'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { date } from '../../lib/helpers';

export default {
  props: [
    'listWilayah',
    'componentsWilayah',
    'activeButton',
    'setActiveButtonParrent',
    'index',
    'removeWilayahParent',
    'setWilayahByIndexParent',
    'kodeWilayah',
    'kodepos',
    'kodeposAll',
  ],
  data: () => ({
    showStatusKodepos: 1,
    disableSwitch: false,
    edited: true,
    listKodepos: [],
    listKodeposSelected: [],
    listKodeposDefault: [],
    searchKodepos: '',
    loadingKodepos: false,
  }),
  computed: {
    allowListWilayah() {
      const filteredArray = this.listWilayah.filter(
        (item1) =>
          !this.componentsWilayah.some(
            (item2) =>
              item2.kode_wilayah === item1.kode_wilayah &&
              item2.kode_wilayah !== this.wilayahUpdate
          )
      );

      return filteredArray;
    },
    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    isData() {
      const kodePosAll = !this.showStatusKodepos
        ? this.kodepos.length > 0
        : true;
      const edit = this.kodeWilayah && kodePosAll;
      return edit;
    },
    disableButton() {
      return !this.edited && this.activeButton;
    },
    wilayahUpdate: {
      get() {
        return this.kodeWilayah;
      },
      set(val) {
        this.resetKodeposAll();
        this.setWilayahByIndexParent(this.index, val, 'kode_wilayah');
      },
    },
    kodeposUpdate: {
      get() {
        return this.kodepos;
      },
      set(val) {
        this.setWilayahByIndexParent(this.index, val, 'kodepos');
      },
    },
    kodeposAllUpdate: {
      get() {
        const status =
          this.kodeposAll || this.kodeposAll != undefined ? this.kodeposAll : 1;

        this.setShowKodepos(status);

        return status;
      },
      set(val) {
        const kodeposAll = val ? 1 : 0;

        this.setShowKodepos(kodeposAll);
        this.setWilayahByIndexParent(this.index, kodeposAll, 'kodepos_all');
        this.checkDisable();
      },
    },
  },
  watch: {
    wilayahUpdate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getListPostalcodeWilayah(val);
          this.disableSwitch = false;
        } else this.disableSwitch = true;

        this.checkDisable();
      },
    },
    kodeposUpdate: {
      immediate: true,
      handler(val) {
        if (val) this.checkAllKodeposObjectList(val);
        this.checkDisable();
      },
    },
    isData: {
      immediate: true,
      handler(val) {
        if (val) this.setChange(false);
      },
    },
    searchKodepos: {
      immediate: true,
      handler() {
        this.getListPostalcodeWilayah(this.wilayahUpdate);
        this.updateListKodepos();
      },
    },
  },
  methods: {
    async checkAllKodeposObjectList(value) {
      await value.map(async (id) => {
        const foundItem = this.listKodepos.find((item) => item.id === id);
        if (foundItem) {
          this.setToList(foundItem);
        } else {
          const notFound = await this.getListPostalcodeWilayahNotFound(
            this.wilayahUpdate,
            id
          );

          if (notFound?.[0]) {
            this.setToList(notFound?.[0]);
          }
        }
      });

      this.updateListKodepos();
    },
    setToList(newItem) {
      const existingItem = this.listKodeposSelected.find(
        (item) => item.id === newItem.id
      );

      if (!existingItem) {
        this.listKodeposSelected.push(newItem);
      }
    },
    getListPostalcodeWilayah(kodeWilayah) {
      if (kodeWilayah) {
        this.loadingKodepos = true;
        this.$store
          .dispatch('users/fetchPostalcode', {
            date,
            kodeWilayah,
            search: { q: this.searchKodepos == null ? '' : this.searchKodepos },
          })
          .then((res) => {
            if (res.length > 0) {
              this.listKodepos = res;
              this.updateListKodepos();
            }
          })
          .finally(() => {
            this.loadingKodepos = false;
          });
      }
    },
    async getListPostalcodeWilayahNotFound(kodeWilayah, searchKodepos) {
      let kodepos = [];
      if (kodeWilayah) {
        kodepos = await this.$store
          .dispatch('users/fetchPostalcode', {
            date,
            kodeWilayah,
            search: { q: searchKodepos == null ? '' : searchKodepos },
          })
          .then((res) => {
            if (res.length > 0) {
              return res;
            }
            return [];
          });
      }
      return kodepos;
    },
    updateListKodepos() {
      const defaultList = this.listKodeposSelected;
      const newList = this.listKodepos;

      const idSet = new Set(defaultList.map((item) => item.id));
      const mergedList = [
        ...defaultList,
        ...newList.filter((item) => !idSet.has(item.id)),
      ];

      this.listKodeposDefault = mergedList;
    },
    setShowKodepos(status) {
      if (status) this.resetKodepos();
      this.showStatusKodepos = status;
    },
    allKodepos() {
      const allKodeposId = this.listKodepos.map((item) => item.id);

      const mergeKodeposId = Array.from(
        new Set(allKodeposId.concat(this.kodeposUpdate))
      );

      this.setWilayahByIndexParent(this.index, mergeKodeposId, 'kodepos');
    },
    resetKodepos() {
      this.setWilayahByIndexParent(this.index, [], 'kodepos');
      this.listKodeposSelected = [];
    },
    resetKodeposAll() {
      this.listKodeposDefault = [];
      this.resetKodepos();
    },
    checkDisable() {
      const kodePosAll = !this.showStatusKodepos
        ? this.kodeposUpdate.length > 0
        : true;

      if (this.wilayahUpdate && kodePosAll) this.setChange(false);
      else this.setChange(true);
    },
    setChange(val) {
      this.setActiveButtonParrent(val);
      this.edited = val;
    },
    removeWilayah(index) {
      this.removeWilayahParent(index);
      this.setChange(false);
    },
  },
};
</script>
